
let loc = window.location.toString();
let isTestOrDev = loc.indexOf("localhost") >= 0 ||
    loc.indexOf("staging") >= 0 ||
    loc.indexOf("isTest") >= 0;
let isDotFr = loc.indexOf("tradefan.fr") >= 0;
let isDotMx = loc.indexOf("tradefan.mx") >= 0;
let isDotCom = loc.indexOf("tradefan.com") >= 0 || (isTestOrDev && !isDotFr && !isDotMx);
let isStaging = isTestOrDev;




const GlobalConst = {
    MEASUREMENT:{
        DESKTOP:{
            NAVIGATION_HEADER_HEIGHT: 60,
            NAVIGATION_FOOTER_HEIGHT: 151,
        },
        MOBILE:{
            NAVIGATION_HEADER_HEIGHT: 50,
            NAVIGATION_FOOTER_HEIGHT: 100,
        }
    },
    TF_API:{
        BASEURL: "https://api.tradefan.com/",
        FULLURL: "https://api.tradefan.com/API"
    },
    API:{
        BASEURL: "https://pickx-api.tradefan.com/",
        FULLURL: "https://pickx-api.tradefan.com/API"
    },
    CDN:{
        BASEURL: "https://cdn.tradefan.com/"
    },
    SITE_URLS:{
        DOMAIN: (()=>{ return isTestOrDev ?     window.location.hostname
                                          : '.'+window.location.hostname.split('.').splice(1,2).join('.') })(),
        TRADEFAN: (()=> {
            if(isTestOrDev) return "https://localhost:8080";
            if(isDotFr) return "https://www.tradefan.fr";
            if(isDotMx) return "https://www.tradefan.mx";
            return "https://www.tradefan.com";
        })()
    },
    FEATURES:{
        DOTFR: isDotFr,
        DOTMX: isDotMx,
        DOTCOM: isDotCom,
        STAGING: isStaging,
        PRIVY_LOGIN: false,
        GOOGLE_LOGIN:  !isDotMx,
        APPLE_LOGIN:  !isDotMx,
        FACEBOOK_LOGIN: false,
        REGISTER_EXTERNAL_PROVIDERS: false,
        ENABLE_LEGACY_PAGES  : false,
        CREATE_YOUR_OWN_PARLAY: {
            SHOW_ADD_MORE_PICK_TEXT: false,
        },
        SHOW_PLAYER_SEASON_STATS: {
            MLB: false,
            NHL: true,
            NBA: false,
            NFL: false,
            SOCCER: false
        },
        SHOW_FIRSTTIMEDEPOSIT_MXN_PROMO_OFFERS: isDotMx,
        SHOW_FIRSTTIMEDEPOSIT_USD_PROMO_OFFERS: isDotCom,
        ADD_FUNDS: !isDotFr,
        GEOFENCE: false,
        PASSWORD_PROTECTED: false,
        PROMO_MARQUEE: false,
        TEMP_PWD: [
            "Y29vbHBpY2t4",
            "ZnVucGlja3g="
        ]
    },
    SITE_CURRENCY: (()=>{
        if (isDotFr) return "EUR";
        if (isDotMx) return "MXN";
        if (isDotCom) return "US";
    })(),
    CURRENCIES_ABBR: {
        US: "USD",
        EUR: "EUR",
        MXN: "MXN",
    },
    SITE_TLD: (()=>{
        if (isDotFr) return ".fr";
        if (isDotMx) return ".mx";
        return ".com";
    })(),
    SITE_LANG: (()=>{
        if (isDotFr) return "fr-FR";
        if (isDotMx) return "es-MX";
        return "en-US";
    })(),
    MIN_WITHDRAW_FUNDS: (()=>{
        if (isDotFr) return 18;
        if (isDotMx) return 425;
        return 25;
    })(),
    MIN_DEPOSIT_FUNDS: (()=>{
        if (isDotFr) return 5;
        if (isDotMx) return 50;
        return 5;
    })(),
    DEFAULT_DEPOSIT_AMOUNT: (()=>{
        if (isDotFr) return 5;
        if (isDotMx) return 50;
        return 10;
    })(),

    SPORTS_IDS: {
        HOCKEY: 1,
        BASKETBALL: 2,
        SOCCER: 3,
        FOOTBALL: 4,
        TENNIS: 5,
        BASEBALL: 9,
        GOLF:12
    },
    LEAGUES_BY_SPORT_ID: {
        1: 'NHL',
        2: 'NBA',
        3: 'SOCCER',
        4: 'NFL',
        9: 'MLB',
        11: 'FIN',
        12: 'GOLF'
    },
    SPORTS_BY_LEAGUE: {
        NHL: 1,
        NBA: 2,
        SOCCER: 3,
        NFL: 4,
        MLB: 9,
        FIN: 11,
        GOLF: 12
    },
    CUSTOM_PARLAY:{
        MIN_PLAYERS: 3,
        MAX_PLAYERS: 8,
        FEES: (
            ()=>{
                if (isDotFr) return [25, 75, 300];
                if (isDotMx) return [25 * 10, 75 * 10, 300 * 10];
                return [25, 75, 300];
            }
        )(),
        WAGER: (
            ()=>{
                if (isDotFr) return 25;
                if (isDotMx) return 50;
                return 25;
            }
        )(),
    },
    LIMIT:{
        TRANSACTION_PAGE_SIZE: 20,
    },
    POPUPS: {
        INSUFFICIENT_FUNDS: "INSUFFICIENT_FUNDS",
        PARLAY_PLACED: "PARLAY_PLACED",
        PLACE_PARLAY_FAILED: "PLACE_PARLAY_FAILED",
    },
    PAYSAFE: {
        API_KEY: "U1VULTI1OTM1MjpCLXAxLTAtNWU2Njk5ZTItMC0zMDJjMDIxNDVhM2ViOWQyMDQ0MTkxNmJlZTU0ZWQzMTkyMjY4NTUwMjgxZGJiZjUwMjE0MjM4ODdiMzljOGI4OTRlMzFiMzMwOTY5NGEyOWQwZGIxMmFkYzkwYg=="
    },
    PROMO:{
        DOUBLE_DEPOSIT:{
            AMOUNT: (()=>{
                if (isDotFr) return 100;
                if (isDotMx) return 1000;
                return 100;
            })()
        }
    },
    PRIVY:{
        AppId:"cmgiclovq00tul40coju4o4vk",
        ClientId:"client-WY6RbA9NSzEgQ3BofxBBQhj4obBiAjsbPUcxsWQUrmVLP"
    }
}

//todo: move in utils
/**
 * Try to get item from local storage
 * @param key
 * @returns {null|string}
 */
export function tryGetFromLocalStorage(key){
    try{
        return localStorage.getItem(key);
    }catch(ex){ return null}
}

export default GlobalConst;